import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "ro";

  const set = (lng) => () => {
    i18n.changeLanguage(lng);
    // ⬇️ Update ?lng= in the address bar (no reload)
    const url = new URL(window.location.href);
    url.searchParams.set("lng", lng);
    window.history.replaceState({}, "", url.toString());
  };

  return (
    <div className="inline-flex rounded-xl overflow-hidden text-sm border border-white/70 bg-white/60 backdrop-blur">
      <button
        onClick={set("ro")}
        className={`px-3 py-1 ${current === "ro" ? "bg-redglass-primary text-white" : "hover:bg-white text-redglass-ink"}`}
        aria-pressed={current === "ro"}
      >
        RO
      </button>
      <button
        onClick={set("en")}
        className={`px-3 py-1 ${current === "en" ? "bg-redglass-primary text-white" : "hover:bg-white text-redglass-ink"}`}
        aria-pressed={current === "en"}
      >
        EN
      </button>
    </div>
  );
}
